export const listMessagesModeration = /* GraphQL */ `
query MyQuery {
  listMessages(filter: {needsModeration: {eq: true}}) {
    items {
      id
      text
      needsModeration
      moderationScore
      moderationLabel
      messageUserId
      User {
        id
        firstName
        lastName
        name
      }
      userID
      chatroomID
    }
    nextToken
  }
}
`